import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import { uploadImage } from '../../api/upload';
/**
 * Multi-image field: upload one or several images (JPG/PNG/WebP) OR paste URLs.
 * Shown as a thumbnail row with per-image removal; order = insertion order.
 */
export function GalleryUploadField({ value, onChange, module, label = 'Images secondaires' }) {
    const inputRef = useRef(null);
    const [uploading, setUploading] = useState(false);
    const [error, setError] = useState('');
    const [urlDraft, setUrlDraft] = useState('');
    const handleFiles = async (files) => {
        if (!files || files.length === 0)
            return;
        setError('');
        setUploading(true);
        try {
            const urls = [];
            for (const file of Array.from(files)) {
                urls.push(await uploadImage(file, module));
            }
            onChange([...value, ...urls]);
        }
        catch (err) {
            setError(err?.response?.data?.error ?? 'Échec du téléversement. Formats acceptés : JPG, PNG, WebP (max 10 Mo).');
        }
        finally {
            setUploading(false);
            if (inputRef.current)
                inputRef.current.value = '';
        }
    };
    const addUrl = () => {
        const url = urlDraft.trim();
        if (!url)
            return;
        onChange([...value, url]);
        setUrlDraft('');
    };
    const remove = (index) => onChange(value.filter((_, i) => i !== index));
    return (_jsxs("div", { children: [_jsx("label", { className: "block text-sm font-medium text-gray-700 mb-1", children: label }), _jsx("p", { className: "text-xs text-gray-400 mb-2", children: "Affich\u00E9es apr\u00E8s l'image principale, dans une galerie d\u00E9roulante sur mobile." }), value.length > 0 && (_jsx("div", { className: "flex flex-wrap gap-2 mb-2", children: value.map((url, i) => (_jsxs("div", { className: "relative", children: [_jsx("img", { src: url, alt: "", className: "h-20 w-20 rounded-lg object-cover border border-gray-200" }), _jsx("button", { type: "button", onClick: () => remove(i), title: "Retirer", className: "absolute -top-1.5 -right-1.5 w-5 h-5 bg-black/60 text-white rounded-full text-[10px] flex items-center justify-center hover:bg-black/80", children: "\u2715" })] }, i))) })), _jsxs("div", { children: [_jsx("button", { type: "button", onClick: () => inputRef.current?.click(), disabled: uploading, className: "px-3 py-2 border rounded-lg text-sm hover:bg-gray-50 disabled:opacity-50", children: uploading ? 'Téléversement…' : 'Ajouter des images' }), _jsx("input", { ref: inputRef, type: "file", accept: "image/jpeg,image/png,image/webp", multiple: true, onChange: (e) => handleFiles(e.target.files), className: "hidden" })] }), _jsxs("div", { className: "flex items-center gap-2 mt-2", children: [_jsx("input", { type: "text", value: urlDraft, onChange: (e) => setUrlDraft(e.target.value), onKeyDown: (e) => { if (e.key === 'Enter') {
                            e.preventDefault();
                            addUrl();
                        } }, placeholder: "ou coller une URL d'image", className: "flex-1 px-3 py-2 border rounded-lg text-sm" }), _jsx("button", { type: "button", onClick: addUrl, className: "shrink-0 px-3 py-2 border rounded-lg text-sm hover:bg-gray-50", children: "Ajouter" })] }), error && _jsx("p", { className: "mt-1 text-xs text-red-500", children: error })] }));
}
